import { LayerLoading, useLoadingMap, useScale } from '@/framework';
import type { ITableLayer } from '@/version-types';
import { getTableCellRects } from './utils/geometry';
import { getTableCellIdsOfLoadingFonts } from './utils/loading';

export const TableLayerLoading = ({ layer }: { layer: ITableLayer }) => {
    const loadingMap = useLoadingMap();
    const scale = useScale();
    const loadingFontFamilies = (loadingMap[layer.id] ?? []).filter(
        (extraInfo): extraInfo is string => typeof extraInfo === 'string',
    );
    const loadingCellIds = new Set(getTableCellIdsOfLoadingFonts(layer.data, loadingFontFamilies));
    const loadingCellRects = getTableCellRects(layer).filter((rect) => loadingCellIds.has(rect.id));

    if (loadingCellRects.length === 0) return null;

    return (
        <div
            style={{
                position: 'relative',
                width: layer.width,
                height: layer.height,
                pointerEvents: 'none',
                transform: `scale(${scale})`,
                transformOrigin: 'top left',
            }}
        >
            {loadingCellRects.map((rect) => (
                <div
                    key={rect.id}
                    style={{
                        position: 'absolute',
                        left: rect.left,
                        top: rect.top,
                        width: rect.width,
                        height: rect.height,
                    }}
                >
                    <LayerLoading scale={1 / scale} />
                </div>
            ))}
        </div>
    );
};
